import { getLocale } from '../../shared/i18n';
export type Row = Record<string, unknown>;
export type Aggregate = { header: Row; lines: Row[]; payment: Row };
export type Detail = { record: Aggregate; version: string };
export type Calculation = { taxes: Row[]; lineDiscount: number; positiveQuantity: number; negativeQuantity: number; postingTotal: number };
export type Metadata = { types: Row[]; taxes: Row[]; warehouses: Row[]; salespeople: Row[]; currency: string; userCode: string; limited: boolean };
export const s = (r: Row | undefined, key: string) => String(r?.[key] ?? '');
export const n = (r: Row | undefined, key: string) => Number(r?.[key] ?? 0);
export const money = (v: unknown, digits = 2) => Number(v ?? 0).toLocaleString(getLocale(), { minimumFractionDigits: digits, maximumFractionDigits: digits });
export const purchaseType = (type: string) => ['AI', 'AF', 'SS'].includes(type);
export const dateValue = (v: unknown) => String(v ?? '').slice(0, 10);
